import { render, staticRenderFns } from "./Dota.vue?vue&type=template&id=25011cd1&scoped=true"
import script from "./Dota.vue?vue&type=script&lang=js"
export * from "./Dota.vue?vue&type=script&lang=js"
import style0 from "./Dota.vue?vue&type=style&index=0&id=25011cd1&prod&lang=less&scoped=true"
import style1 from "./Dota.vue?vue&type=style&index=1&id=25011cd1&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_675154ded190a7e2d3ad9efb69cc05e3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25011cd1",
  null
  
)

export default component.exports